import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { queryClient, WORKSPACE_QUERY_OPTIONS } from "../app/queryClient";
import { useAppSelector } from "../app/hooks";
import { fetchDashboardHome } from "../lib/api/dashboard";
import { getVisibleWorkspaceNavItems } from "../features/auth/access";
import { resolveActiveWorkspaceItem } from "../routes/moduleNavigation.utils";
import { getActiveWorkspaceItem } from "../routes/navigation";
import { prefetchWorkspaceModule } from "../routes/modulePrefetch";

export function useWorkspaceWarmup() {
    const user = useAppSelector((state) => state.auth.user);
    const location = useLocation();
    const hasWarmedRef = useRef(false);

    useEffect(() => {
        if (!user || hasWarmedRef.current) {
            return;
        }

        hasWarmedRef.current = true;

        void queryClient.prefetchQuery({
            queryKey: ["dashboard-home"],
            queryFn: fetchDashboardHome,
            ...WORKSPACE_QUERY_OPTIONS,
        });

        const visiblePaths = getVisibleWorkspaceNavItems(user).map((item) => item.path);

        if (visiblePaths.length === 0) {
            return;
        }

        const activeItem =
            resolveActiveWorkspaceItem(location.pathname, location.search)
            ?? getActiveWorkspaceItem(location.pathname);
        const activePath = visiblePaths.find((path) => path === activeItem.path) ?? visiblePaths[0];

        prefetchWorkspaceModule(activePath);

        return undefined;
    }, [location.pathname, user]);
}
